"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsPostalCodeValidator {
    constructor(locale) {
        this.locale = locale;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isPostalCode(input, this.locale);
        }
        return false;
    }
}
exports.IsPostalCodeValidator = IsPostalCodeValidator;
//# sourceMappingURL=IsPostalCodeValidator.js.map